<script setup>
import Pencil from "~/components/icons/Pencil.vue";

const props = defineProps({
    value: {
        type: Boolean,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['update:value']);

const updateValue = () => {
    emit('update:value', true);
};
</script>

<template>
    <div class="bg-gray-1 px-4 py-4 rounded-lg w-full flex justify-between mb-3" >

        <div class="flex flex-col gap-4 lg:flex-row flex-wrap w-full lg:gap-x-0 lg:pl-2 lg:py-2">

            <slot></slot>

        </div>

        <button class="self-start" v-show="editable" @click="updateValue" aria-label="button to enable input changes" type="button">

            <Pencil />
            
        </button>

    </div>
</template>